import _typeof from "babel-runtime/helpers/typeof";
import _toConsumableArray from "babel-runtime/helpers/toConsumableArray";
/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Helper methods
 * -----------------------------------------------------------------------------
 *
 * @namespace helpers
 */

import moment from 'moment';
import 'moment/locale/es';
// In case you want to change moment.js locale, here is an example:
/*
import 'moment/locale/en-gb'
moment.locale('en-gb')
*/

var swatchesColorList = JSON.parse($('[data-swatches-colorlist-json]').html());

var helperMethods = {
  methods: {

    /**
     * Helper method for getting the current template
     */
    _getCurrentTemplate: function _getCurrentTemplate() {
      var template = $('[data-template]').data('template');

      switch (template) {
        case 'collection':
          app.currentTemplate = 'collection';
          break;
        case 'product':
          app.currentTemplate = 'product';
          break;
        case 'cart':
          app.currentTemplate = 'cart';
          break;
        case 'search':
          app.currentTemplate = 'search';
          break;
        case 'account':
          app.currentTemplate = 'account';
          break;
        case 'compare_page':
          app.currentTemplate = 'compare_page';
          break;
        case 'orderTracking':
          app.currentTemplate = 'orderTracking';
          break;
        case 'orderTrackingResult':
          app.currentTemplate = 'orderTrackingResult';
          break;
        case 'customForm':
          app.currentTemplate = 'customForm';
          break;
        case 'kitchen-box':
          app.currentTemplate = 'kitchen-box';
          break;
        case 'my-orders':
          app.currentTemplate = 'my-orders';
          break;
      }
    },


    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    _findInstance: function _findInstance(array, key, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
      return null;
    },


    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    _removeInstance: function _removeInstance(array, key, value) {
      var i = array.length;
      while (i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }
      return array;
    },
    _snotifyMessage: function _snotifyMessage(title, details) {
      app.$snotify.error(details, title, {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        buttons: [{
          text: 'Close',
          bold: true,
          closeOnClick: true
        }]
      });
    },
    _snotifyMessageSuccess: function _snotifyMessageSuccess(title, details) {
      app.$snotify.success(details, title, {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        buttons: [{
          text: 'Close',
          bold: true,
          closeOnClick: true
        }]
      });
    },


    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    _compact: function _compact(array) {
      var index = -1;
      var length = array == null ? 0 : array.length;
      var resIndex = 0;
      var result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },


    /**
     * Remove duplicates from an array of objects
     * @param arr - Array of objects
     * @param prop - Property of each object to compare
     * @returns {Array}
     */
    _removeDuplicates: function _removeDuplicates(arr) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

      var map = new Map();
      // eslint-disable-next-line array-callback-return
      arr.map(function (el) {
        if (!map.has(el[key])) {
          map.set(el[key], el);
        }
      });
      return [].concat(_toConsumableArray(map.values()));
    },


    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    _defaultTo: function _defaultTo(value, defaultValue) {
      return value == null ? defaultValue : value;
    },


    /**
     * Format date
     * @param  {string}
     * @return {String} value - formatted value
     */
    _formatDate: function _formatDate(value) {
      var date = moment(value).utc().format('MMM D, YYYY');
      return date;
    },


    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @return {String} value - formatted value
     */
    _formatMoney: function _formatMoney(cents) {
      var app = this;
      var moneyFormat = app.moneyFormat;

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = app._defaultTo(precision, 2);
        thousands = app._defaultTo(thousands, ',');
        decimal = app._defaultTo(decimal, '.');

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    },


    /**
     * Gets the text of an element and converts to current currency
     *
     * @returns {*} - Returns the new text (currency) of the element
     */
    _checkCurrencyElements: function _checkCurrencyElements() {
      var $currencyEl = $('[data-currency]');
      var amount = $currencyEl.text() * 100;
      var money = app._formatMoney(amount);
      $currencyEl.text(money);
    },


    /**
     * Converts a string to camelcase
     *
     * @param {*} str - String to check
     * @returns {*} - Returns the resolved string
     */
    _toCamelCase: function _toCamelCase(str) {
      return str.toLowerCase().replace(/(?:(^.)|(\s+.))/g, function (match) {
        return " " + match.charAt(match.length - 1).toUpperCase();
      });
    },


    /**
     * Converts a string as handle
     *
     * @param {*} str - String to check
     * @returns {*} - Returns the resolved string
     */
    _handleize: function _handleize(str) {
      str = str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '');
      return str;
    },


    /**
     * Converts a handle to readable friendly format
     *
     * @param {*} str - String to check
     * @returns {*} - Returns the resolved string
     */
    _unhandleize: function _unhandleize(str) {
      str = str.replace(/-/g, ' ');
      str = this._toCamelCase(str);
      return str;
    },


    /**
     * Truncates a given string
     *
     * @param {String} value - Value to check
     * @param {Number} count - Count number of words
     * @returns {*} - Returns the resolved value
     */
    _truncate: function _truncate(value, count) {
      var strippedString = value.trim();
      var array = strippedString.split(' ');
      value = array.splice(0, count).join(' ');
      if (array.length > count) {
        value += '...';
      }
      return value;
    },


    /**
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     */
    _debounce: function _debounce(func, wait, immediate) {
      var timeout = void 0;
      return function () {
        var context = this;
        var args = arguments;

        function later() {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        }

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    },


    /**
     * Pre-loads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    _preload: function _preload(images, size) {
      var app = this;

      if (typeof images === 'string') {
        images = [images];
      }

      for (var i = 0; i < images.length; i += 1) {
        var image = images[i];
        app._loadImage(app._getSizedImageUrl(image, size));
      }
    },


    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    _loadImage: function _loadImage(path) {
      new Image().src = path;
    },


    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    _imageSize: function _imageSize(src) {
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match) {
        return match[1];
      }
      return null;
    },


    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param {string} src
     * @param {string} size
     * @returns {*}
     */
    _getSizedImageUrl: function _getSizedImageUrl(src, size) {
      var app = this;
      var match = void 0;

      if (src === null) {
        return;
      }

      if ((typeof src === "undefined" ? "undefined" : _typeof(src)) === 'object') {
        src = src.src;
      }

      if (size === 'master') {
        src = app._removeProtocol(src);
      }

      if (src) {
        match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      }

      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        src = app._removeProtocol(prefix[0] + "_" + size + suffix);
      }
      return src;
    },


    /**
     * Get swatch hex color code or image url
     *
     * @param {string} colorName
     * @returns {string} hex code
     */
    _getSwatchStyle: function _getSwatchStyle(colorName) {
      colorName = colorName.replace(/-|\s/g, '').toLowerCase();
      var swatch = swatchesColorList[colorName];
      var swatchStyle = void 0;

      if (typeof swatch !== 'undefined') {
        if (swatch.match(/\.(jpeg|jpg|png|gif)/g) != null) {
          swatchStyle = "background-image: url(" + swatch + ")";
        } else {
          swatchStyle = "background-color: " + swatch;
        }
        return swatchStyle;
      }

      return false;
    },
    _removeProtocol: function _removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    },


    /**
     * Read a stored cookie by name
     *
     * @param {string} name
     * @return {String} value
     */
    _getCookie: function _getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");

      if (parts.length === 2) {
        name = parts.pop().split(';').shift();
      }
      return name;
    },


    /**
     * Cross browser resize event
     */
    _triggerResize: function _triggerResize() {
      if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
      } else {
        window.dispatchEvent(new Event('resize'));
      }
    },


    /**
     * Get URL parameter
     */
    _getUrlParameter: function _getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    _removeURLParameter: function _removeURLParameter(url, parameter) {
      //prefer to use l.search if you have a location/link object
      var urlparts = url.split('?');
      if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);
        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
          //idiom for string.startsWith
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            pars.splice(i, 1);
          }
        }
        url = urlparts[0] + '?' + pars.join('&');
        return url;
      } else {
        return url;
      }
    },


    /**
     * Convert Date formate
     */

    // mab b not used
    _convertDate: function _convertDate(originaldate) {
      var date = new Date(originaldate);

      var monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

      var days = ['Dom', 'Lun', 'Mar', 'Miér', 'Jue', 'Vie', 'Sáb'];

      var year = date.getFullYear(),
          month = monthNames[date.getMonth()],
          shipping_ddate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
          shipping_day = days[date.getDay()];

      var converted_date = shipping_day + ', ' + month + ' ' + shipping_ddate + '<span class="d-none">' + year + '</span>';

      return converted_date;
    },
    _convertSlashDate: function _convertSlashDate(originaldate) {
      var dateConvert = moment(originaldate);
      dateConvert.locale('es');
      var moment_date = dateConvert.format('DD') + ' / ' + dateConvert.format('MM') + ' / ' + dateConvert.format('YYYY');
      return moment_date;
    },
    _convertShortDate: function _convertShortDate(originaldate) {
      var date = new Date(originaldate);

      var monthNames = ['Ene', 'Feb', 'Mar', 'Abril', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Octubre', 'Nov', 'Dic'];

      var year = date.getFullYear(),
          month = monthNames[date.getMonth()],
          shipping_ddate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

      var converted_date = shipping_ddate + ' ' + month + ' ' + +year;

      var dateConvert = moment(originaldate);
      dateConvert.locale('es');
      var date1 = dateConvert.format('dddd');
      var date2 = dateConvert.format('D');
      var date3 = dateConvert.format('MMMM');
      var date4 = dateConvert.format('YYYY');

      var moment_date = dateConvert.format('DD') + ' ' + dateConvert.format('MMMM').slice(0, 3) + ' ' + dateConvert.format('YYYY');

      return moment_date;
    },
    _convertsplitDate: function _convertsplitDate(originaldate) {

      var date1 = new Date(originaldate.split(' - ')[0]);
      var date2 = new Date(originaldate.split(' - ')[1]);

      var monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

      var days = ['Dom', 'Lun', 'Mar', 'Miér', 'Jue', 'Vie', 'Sáb'];

      var year1 = date1.getFullYear(),
          month1 = monthNames[date1.getMonth()],
          shipping_ddate1 = date1.getDate() < 10 ? '0' + date1.getDate() : date1.getDate(),
          shipping_day1 = days[date1.getDay()];

      var year2 = date2.getFullYear(),
          month2 = monthNames[date2.getMonth()],
          shipping_ddate2 = date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate(),
          shipping_day2 = days[date2.getDay()];

      var converted_date1 = shipping_day1 + ', ' + month1 + ' ' + shipping_ddate1 + '<span class="d-none">' + year1 + '</span>';
      var converted_date2 = shipping_day2 + ', ' + month2 + ' ' + shipping_ddate2 + '<span class="d-none">' + year2 + '</span>';

      return converted_date1 + ' - ' + converted_date2;
    },
    _convertsplitShortDate: function _convertsplitShortDate(originaldate) {
      var newDate1 = originaldate.split(' - ')[0].split(':')[1];
      var date1 = new Date(newDate1);
      var date2 = new Date(originaldate.split(' - ')[1]);

      var monthNames = ["Ene", "Feb", "Mar", "Abril", "Mayo", "Jun", "Jul", "Ago", "Sep", "Octubre", "Nov", "Dic"];

      var days = ['Dom', 'Lun', 'Mar', 'Miér', 'Jue', 'Vie', 'Sáb'];

      var year1 = date1.getFullYear(),
          month1 = monthNames[date1.getMonth()],
          shipping_ddate1 = date1.getDate() < 10 ? '0' + date1.getDate() : date1.getDate(),
          shipping_day1 = days[date1.getDay()];

      var year2 = date2.getFullYear(),
          month2 = monthNames[date2.getMonth()],
          shipping_ddate2 = date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate(),
          shipping_day2 = days[date2.getDay()];

      var converted_date1 = shipping_ddate1;
      var converted_date2 = shipping_ddate2 + ' ' + month2 + ' ' + +year2;

      // converted_date1 +' - '+converted_date2

      if (originaldate.indexOf(':') > -1) {
        var newDate2 = originaldate.split(' - ')[0].split(':')[1];
      } else {
        var newDate2 = originaldate.split(' - ')[0];
      }
      var dateConvert1 = moment(newDate2);
      dateConvert1.locale('es');
      var dateConvert2 = moment(originaldate.split(' - ')[1]);
      dateConvert2.locale('es');

      var moment_date = dateConvert1.format('DD') + ' - ' + dateConvert2.format('DD') + ' ' + dateConvert2.format('MMMM').slice(0, 3) + ' ' + dateConvert2.format('YYYY');

      return moment_date;
    },
    _setNextDay: function _setNextDay(format) {
      var today = new Date();
      var tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      var monthNames = ["Ene", "Feb", "Mar", "Abril", "Mayo", "Jun", "Jul", "Ago", "Sep", "Octubre", "Nov", "Dic"];

      var year = tomorrow.getFullYear(),
          month = monthNames[tomorrow.getMonth()],
          shipping_ddate = tomorrow.getDate() < 10 ? '0' + tomorrow.getDate() : tomorrow.getDate();

      var converted_date = shipping_ddate + ' ' + month + ' ' + +year;

      var dayINeed = 5; // for Friday
      var dayToday = moment().isoWeekday();

      if (dayToday < dayINeed) {
        var dateConvert = moment().add(1, 'days');
      } else {
        if (dayToday == 5) {
          var dateConvert = moment().add(3, 'days');
        } else if (dayToday == 6) {
          var dateConvert = moment().add(2, 'days');
        } else if (dayToday == 7) {
          var dateConvert = moment().add(1, 'days');
        }
      }

      dateConvert.locale('es');

      var moment_date = dateConvert.format('DD') + ' ' + dateConvert.format('MMMM').slice(0, 3) + ' ' + dateConvert.format('YYYY');
      var moment_date_num = dateConvert.format('YYYY') + '-' + dateConvert.format('MM') + '-' + dateConvert.format('DD');

      if (format == 'numeric') {
        return moment_date_num;
      } else {
        return moment_date;
      }
    },
    _compareDate: function _compareDate(date1, date2) {
      if (date1 && date1 != '' && date2 && date2 != '') {
        return Math.ceil(Math.abs(new Date(date1) - new Date(date2)) / (1000 * 60 * 60 * 24));
      }
    },
    _initAutocomplete: function _initAutocomplete() {
      var address1Field = document.querySelector("#ship-address");
      var address2Field = document.querySelector("#address2");
      var postalField = document.querySelector("#postcode");

      var isPlaceChanged = false;

      var selector = $('#ship-address');
      var autocompleteService = new google.maps.places.AutocompleteService();
      var placeService = new google.maps.places.PlacesService(window.document.createElement('div'));

      app.cart.selPrediction = false;

      //Capture text input
      selector.on('input', app._debounce(function (e) {
        if ($(this).val()) {
          var autocompleteRequest = {
            input: selector.val(),
            componentRestrictions: {
              country: "cl" // country: string | string[];
            }
          };
          //Call google api to get results
          autocompleteService.getPredictions(autocompleteRequest, app._autoCompletecallBack);
        } else {
          // hide dropdown
          $('#resultDropDown').hide();
        }
        //debounce call to avoid call google API every time a key is pressed
      }, 1000));

      selector.on('keyup', function (e) {
        //Capture keydown & keyup to select item inside results dropdown
        var $listItems = $('#resultDropDown').children();
        var key = e.keyCode;
        var $selected = $listItems.filter('.pac-item-selected');
        var $current;
        $listItems.removeClass('pac-item-selected');
        if (key == 40) {
          // Down key
          if ($listItems.length > 0 && selector.val()) {
            $('#resultDropDown').show();
          } else {
            return;
          }

          if (!$selected.length || $selected.is(':last-child')) {
            $current = $listItems.eq(0);
          } else {
            $current = $selected.next();
          }
          $current.addClass('pac-item-selected');
        } else if (key == 38) {
          // Up key
          if ($listItems.length > 0 && selector.val()) {
            $('#resultDropDown').show();
          }
          if (!$selected.length || $selected.is(':first-child')) {
            $current = $listItems.last();
          } else {
            $current = $selected.prev();
          }
          $current.addClass('pac-item-selected');
        } else if (key == 13) {
          // Enter
          if ($selected.length > 0) {
            app._getPlaceDetails($selected.eq(0));
          }
        }
      });

      $(document).click(function (event) {
        if ($(event.target).is($('#ship-address'))) {
          var $listItems = $('#resultDropDown').children();
          if ($listItems.length > 0 && $('#ship-address').val()) {
            $('#resultDropDown').show();
          }
        } else {
          // hide dropdown
          $('#resultDropDown').hide();
        }
      });

      $('#ship-address').blur(function () {
        if ($('#ship-address').val() == '') {
          $('.button-overlay').removeClass('d-none');
        }
        if ($('#ship-address').val() != '' && !/\d/.test($('#ship-address').val())) {
          $('.numeric_only_error').removeClass('d-none');
          $('.numeric_error').addClass('d-none');
          $('.addlength_error').addClass('d-none');
          $('#ship-address').addClass('input-error');
          $('.button-overlay').removeClass('d-none');
        }
        return false;
      });

      if (app._getCookie('selectedaddress1') == undefined && app._getCookie('selectedaddress1') == '' && app._getCookie('selectedaddress1') == 'selectedaddress1') {
        $('[data-regions], [data-district]').attr('disabled', 'disabled');
      }

      $('.button-overlay').on('click', function () {
        $('.show-autocon .checkbox-wrapper label').addClass('checkbox_error');
        if ($('.div-autocomp').hasClass('show-autocon')) {
          $('.no-direction').addClass('shake');
          setTimeout(function () {
            $('.no-direction').removeClass('shake');
          }, 400);
        }
      });

      $('.checkbox-wrapper input#checkout_verify_address').change(function () {
        if (this.checked && $('.show-autocon [name="ship-addr"]').val() != '') {
          if ($('.show-autocon #checkout_verify_address').prop('checked') == true && $('.show-autocon .checkbox-wrapper').is(':visible') && $('.show-autocon [data-regions]').val() != null && $('.show-autocon [data-district]').val() != null && $('.show-autocon .numeric_error').is(':visible') == false && $('.show-autocon .numeric_only_error').is(':visible') == false) {
            $('.button-overlay').addClass('d-none');
            $('[data-shipping-check]').removeClass('button-hidden');
          }
        } else {
          if ($('.show-autocon [name="ship-addr"]').val() != '') {
            $('.button-overlay').removeClass('d-none');
            $('[data-shipping-check]').removeClass('button-hidden');
          }
        }
      });
    },
    _highlightSearchStrings: function _highlightSearchStrings(description, matches) {
      var insertionPoints = [];
      // Build markup to render in output
      for (var j in matches) {
        insertionPoints.push({
          location: matches[j].offset,
          val: '<span class="pac-item-query">'
        });
        insertionPoints.push({
          location: matches[j].offset + matches[j].length,
          val: '</span>'
        });
      }
      // Sort offset insertion points
      insertionPoints.sort(function (a, b) {
        return b.location - a.location;
      });
      // Insert markup in output
      for (var j in insertionPoints) {
        description = description.substring(0, insertionPoints[j].location) + insertionPoints[j].val + description.substring(insertionPoints[j].location);
      }
      // Return output
      return description;
    },
    _autoCompletecallBack: function _autoCompletecallBack(predictions, status) {

      if (status != google.maps.places.PlacesServiceStatus.OK) {
        console.log(status);
        return;
      }
      var resultHTML = '';
      //Fill results dropdown
      predictions.forEach(function (prediction) {
        var output = app._highlightSearchStrings(prediction.description, prediction.matched_substrings);
        resultHTML += '<div class="pac-item" data-placeid="' + prediction.place_id + '" data-name="' + prediction.terms[0].value + '">' + '<span class="pac-icon pac-icon-marker"></span>' + output + '</div>';
      });
      if (resultHTML != undefined && resultHTML != '') {
        $('#resultDropDown').html(resultHTML).show();
      }

      $(".pac-item").on('click', function () {
        app._getPlaceDetails($(this));
      });
    },
    _getPlaceDetails: function _getPlaceDetails(item) {
      var placeId = item.data("placeid");
      var placeService = new google.maps.places.PlacesService(window.document.createElement('div'));
      placeService.getDetails({ placeId: placeId }, app._fillInAddress);
    },
    _fillInAddress: function _fillInAddress(place, status) {
      var address1Field = document.querySelector("#ship-address");
      var address2Field = document.querySelector("#address2");
      var address1 = '';
      var postcode = '';
      app.cart.selPrediction = true;

      var street_count = 0;
      var comchange = 0;

      var _loop = function _loop(component) {
        var componentType = component.types[0];
        // console.log(component);
        switch (componentType) {
          case 'route':
            {
              address1 = component.long_name + " " + address1 + " ";
              break;
            }

          case 'street_number':
            {
              address1 += "" + component.long_name;
              // address1 += `${component.long_name} ${address1} `;
              street_count += 1;
              break;
            }

          case 'postal_code':
            {
              postcode = "" + component.long_name + postcode;
              break;
            }

          case 'postal_code_suffix':
            {
              postcode = postcode + "-" + component.long_name;
              break;
            }
          case 'locality':
            setTimeout(function () {
              $('[data-district] option').each(function () {
                var compnent_des = $(this).val().replace(/í/g, 'i').replace(/á/g, 'a').replace(/Á/g, 'A');
                compnent_des = compnent_des.replace(/á/g, 'a').replace(/Á/g, 'A');
                compnent_des = compnent_des.replace(/Á/g, 'A');
                $(this).val(compnent_des);
              });
              var compo_long_name = component.long_name;
              compo_long_name = compo_long_name.replace(/í/g, 'i').replace(/á/g, 'a').replace(/Á/g, 'A');
              if ($("[data-district] option[value=\"" + compo_long_name + "\"]").length > 0) {
                $('[data-district]').val(compo_long_name).trigger('change');
                comchange = 1;
                if (street_count == 0) {
                  $('[data-district],[data-regions]').removeAttr('disabled');
                } else {
                  $('[data-district],[data-regions]').attr('disabled', 'disabled');
                  // $('.checkbox-wrapper').addClass('d-none');
                }
              } else {
                $('[data-regions]').removeAttr('disabled');
                // $('.checkbox-wrapper').removeClass('d-none');
                $('[data-district] option[value=""]').removeAttr('disabled');
                $('[data-district]').val("").trigger('change');
                $('[data-district] option[value=""]').attr('disabled', 'disabled');
                $('[data-district]').removeAttr('disabled');
              }
            }, 500);
            break;
          case 'administrative_area_level_3':
            {
              setTimeout(function () {
                if (comchange == 0) {
                  $('[data-district] option').each(function () {
                    // let compnent_des = $(this).val().replaceAll('í','i').replaceAll('á','a').replaceAll('Á','A');
                    var compnent_des = $(this).val().replace(/í/g, 'i');
                    compnent_des = compnent_des.replace(/á/g, 'a');
                    compnent_des = compnent_des.replace(/Á/g, 'A');
                    $(this).val(compnent_des);
                  });
                  var compo_long_name = component.long_name;
                  // compo_long_name = compo_long_name.replaceAll('í','i').replaceAll('á','a').replaceAll('Á','A');
                  compo_long_name = compo_long_name.replace(/í/g, 'i');
                  compo_long_name = compo_long_name.replace(/á/g, 'a');
                  compo_long_name = compo_long_name.replace(/Á/g, 'A');
                  if ($("[data-district] option[value=\"" + compo_long_name + "\"]").length > 0) {
                    $('[data-district]').val(compo_long_name).trigger('change');
                    if (street_count == 0) {
                      $('[data-district],[data-regions]').removeAttr('disabled');
                    } else {
                      $('[data-district],[data-regions]').attr('disabled', 'disabled');
                      // $('.checkbox-wrapper').addClass('d-none');
                    }
                  } else {
                    $('[data-regions]').removeAttr('disabled');
                    // $('.checkbox-wrapper').removeClass('d-none');
                    $('[data-district] option[value=""]').removeAttr('disabled');
                    $('[data-district]').val("").trigger('change');
                    $('[data-district] option[value=""]').attr('disabled', 'disabled');
                    $('[data-district]').removeAttr('disabled');
                  }
                }
              }, 500);
              break;
            }
          case 'administrative_area_level_1':
            {
              // eslint-disable-next-line no-var
              getregion = '';

              $('[data-regions] option').each(function () {
                var data_origin = $(this).val();
                var data_shortval = $(this).val().toLowerCase().replace('región de ', '').replace('región del ', '').replace('región ', '');

                var compnent_region = component.short_name;
                compnent_region = compnent_region.toLowerCase().replace('región de ', '').replace('región del ', '').replace('región ', '');

                if (compnent_region == 'bío bío') {
                  // compnent_region = compnent_region.replace(' ','').replaceAll('í','i');
                  compnent_region = compnent_region.replace(' ', '');
                  compnent_region = compnent_region.replace(/í/g, 'i');
                }

                if (data_shortval.indexOf(compnent_region) > -1) {
                  getregion = data_origin;
                }
              });

              if ($('[data-regions] option[value="' + getregion + '"]').length > 0) {
                $('[data-regions]').val(getregion).trigger('change');
                if (street_count == 0) {
                  $('[data-regions]').removeAttr('disabled');
                  $('.button-overlay').removeClass('d-none');
                } else {
                  $('[data-regions]').attr('disabled', 'disabled');
                  $('[data-district]').attr('disabled', 'disabled');
                  $('.button-overlay').addClass('d-none');
                }
              } else {
                $('[data-regions] option[value=""]').removeAttr('disabled');
                $('[data-regions]').val("").trigger('change');
                $('[data-regions] option[value=""]').attr('disabled', 'disabled');
                $('[data-regions]').removeAttr('disabled');
                $('[data-district]').removeAttr('disabled');
                $('.button-overlay').removeClass('d-none');
              }
              break;
            }
          case "country":
            break;
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = place.address_components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var component = _step.value;
          var getregion;

          _loop(component);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (street_count == 0) {
        $('.numeric_error').addClass('d-none');
        $('.numeric_only_error').removeClass('d-none');
        $('.addlength_error').addClass('d-none');
        $('#ship-address').addClass('input-error');
      } else {
        $('.numeric_error').addClass('d-none');
        $('.numeric_only_error').addClass('d-none');
        if (address1.length < 6) {
          $('.addlength_error').removeClass('d-none');
        } else {
          $('.addlength_error').addClass('d-none');
          $('#ship-address').removeClass('input-error');
        }
      }
      address1Field.value = address1;
      address2Field.focus();
    }
  }
};

export default helperMethods;